import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { Button, TextButton } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { socialXBunja } from './bunja';

export function SocialXSection() {
  const { isLoadingAtom, xConnectionAtom, connect, disconnect } = useBunja(socialXBunja);
  const isLoading = useAtomValue(isLoadingAtom);
  const connection = useAtomValue(xConnectionAtom);
  return (
    <div className={stack({ gap: 12, w: '100%', textStyle: 'Text/L/Strong', color: 'content.default.level-4' })}>
      <div className={hstack({ justify: 'space-between' })}>
        <div className={hstack({ justify: 'center', gap: 4 })}>
          <p>Connect X to Flipster</p>
        </div>
        {!connection && (
          <Button
            hierarchy='primary'
            color='neutral'
            label='Connect'
            onClick={connect}
            isLoading={isLoading}
            withSpinner
          />
        )}
      </div>
      {connection && (
        <div className={stack({ gap: 8, align: 'flex-start' })}>
          <div className={hstack({ justify: 'center', gap: 4 })}>
            <p className={css({ textStyle: 'Text/L/Regular' })}>Connected as </p>
            <p>@{connection.username}</p>
          </div>
          <TextButton color='passive' label='Disconnect' onClick={disconnect} />
        </div>
      )}
    </div>
  );
}
